module.exports = __webpack_public_path__ + "media/images/emp/nist_logo_b-6fa108d63469f0aacac2a5a2d8c7c530.png";